export default __webpack_public_path__ + "static/media/sv_12.14e96e6e.webp";